// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outlinedListItem[data-v-1a515b6a]{border:1px solid #ccc;border-radius:16px}", ""]);
// Exports
module.exports = exports;
